import { render, staticRenderFns } from "./PerfilAcessoListAddNew.vue?vue&type=template&id=796f9204&"
import script from "./PerfilAcessoListAddNew.vue?vue&type=script&lang=js&"
export * from "./PerfilAcessoListAddNew.vue?vue&type=script&lang=js&"
import style0 from "./PerfilAcessoListAddNew.vue?vue&type=style&index=0&id=796f9204&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports